// extracted by mini-css-extract-plugin
module.exports = {"stack":"StackedBar--stack--3-lST","fixedHeight":"StackedBar--fixedHeight--cQ4Vh","targetLine":"StackedBar--targetLine--141Co"};